export default "__VITE_ASSET__B8Hntk1k__"